<div id="v-profile" class="tab-pane" role="tabpanel" aria-labelledby="profile-tab">
  <section class="section">
    <div class="container">
      <div class="center" *ngIf="spin" style="margin-top: 200px">
        <app-spinner [enabled]="spin" [size]="'120px'" [class]="'text-primary'"></app-spinner>
      </div>
      <div *ngIf="!spin">
        <form [formGroup]="editPerson" class="userForm">
          <div class="row row-cols-1">
            <div class="col">
              <a *ngIf="this.cuid" class="more-rev more-bold d-inline-block mb-4" (click)="goBack()"
                href="javascript:void(0)" translate>back</a>
              <div class="d-block d-md-flex">
                <div class="application-avatar-text mr-3 mb-2 mb-md-0">
                  {{
                  editPerson.get(['name', 'given'])?.value.charAt(0)
                  | uppercase
                  }}{{
                  editPerson.get(['name', 'surname'])?.value.charAt(0)
                  | uppercase
                  }}
                </div>
                <div>
                  <div class="d-flex flex-shrink-1 align-items-center">
                    <h2 class="h4 d-inline mb-0 text-truncate header-user-name" title="{{ getFullName() | titlecase }}">
                      {{ getFullName() | titlecase }}
                    </h2>
                    <ng-container [ngSwitch]="editPerson.controls.status.value">
                      <div class="ml-1 pill pill-sm text-sm bg-success text-white" *ngSwitchCase="'active'" translate>
                        active
                      </div>
                      <div class="ml-1 pill pill-sm text-sm bg-secondary text-white" *ngSwitchCase="'pending'"
                        translate>
                        pending
                      </div>
                      <div class="ml-1 pill pill-sm text-sm locked" *ngSwitchCase="'locked'" translate>
                        locked
                      </div>
                      <div class="ml-1 pill pill-sm text-sm unactivated" *ngSwitchCase="'unactivated'" translate>
                        unactivated
                      </div>
                      <div class="ml-1 pill pill-sm text-sm bg-suspended text-white" *ngSwitchCase="'suspended'"
                        translate>
                        suspended
                      </div>
                      <div class="ml-1 pill pill-sm text-sm bg-deleted text-white" *ngSwitchCase="'inactive'" translate>
                        deleted
                      </div>
                      <div class="ml-1 pill pill-sm text-sm bg-success text-white" *ngSwitchDefault>
                        {{ editPerson.controls.status.value }}
                      </div>
                    </ng-container>
                  </div>
                  <div class="mt-2" [hidden]="hideOrganisation">
                    <strong translate>account</strong>&nbsp;
                    <ng-container [ngSwitch]="this.organisationName">
                      <span *ngSwitchCase="'Partner'" translate>partner</span>
                      <span *ngSwitchCase="'Customer'" translate>customer</span>
                      <span *ngSwitchDefault>{{
                        this.organisationName | titlecase
                        }}</span>
                    </ng-container>
                  </div>
                  <div class="mt-1">
                    <strong translate>user-id</strong>&nbsp;
                    <span class="text-truncate header-user-id" isEllipsisActive>
                      {{
                      editPerson.controls.username.value || this.userName
                      | titlecase
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4" *ngIf="this.cuid">
            <div class="col-12">
              <ul class="list-unstyled d-block d-md-flex flex-wrap mb-0">
                <li>
                  <button *ngIf="showReprocess" id="user-reprocess"
                    class="btn btn-sm btn-light font-weight-bold text-body mt-2 mr-2" (click)="submitReprocess()"
                    translate>
                    reprocess-user
                    <app-spinner [enabled]="submitSpinnerReprocess" [size]="'18px'"
                      [class]="'text-body ml-2'"></app-spinner>
                  </button>
                </li>
                <li>
                  <button *ngIf="showResendPassword" id="user-resend-password"
                    class="btn btn-sm btn-light font-weight-bold text-body mt-2 mr-2" (click)="resendPassword()"
                    translate>
                    resend-password-link
                    <app-spinner [enabled]="submitSpinnerPasswordLink" [size]="'18px'"
                      [class]="'text-body ml-2'"></app-spinner>
                  </button>
                </li>
                <li>
                  <button *ngIf="showResetPassword" id="user-reset-password"
                    class="btn btn-sm btn-light font-weight-bold text-body mt-2 mr-2"
                    (click)="isResetPasswordShown = !isResetPasswordShown">
                    Reset password
                  </button>
                </li>
                <!-- Currently commented as the Unlock Feature is planned for Future Release -->
                <!-- <li>
                                    <button *ngIf="showUnlock" id="user-unlock" class="btn btn-sm btn-light font-weight-bold text-body mt-2 mr-2" (click)="unlockPerson()">Unlock
                                        <app-spinner [enabled]="submitSpinnerUnlock" [size]="'18px'" [class]="'text-body ml-2'"></app-spinner>
                                    </button>
                                </li> -->
                                <li>
                                    <button *ngIf="showUnsuspend" id="user-unsuspend" class="btn btn-sm btn-light font-weight-bold text-body mt-2 mr-2" (click)="unsuspendPerson()">Unsuspend
                                        <app-spinner [enabled]="submitSpinnerUnsuspend" [size]="'18px'" [class]="'text-body ml-2'"></app-spinner>
                                    </button>
                                </li>
                                <li>
                                    <button *ngIf="showSuspend" id="user-suspend" class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" (click)="suspendPerson()">Suspend
                                        <app-spinner [enabled]="submitSpinnerSuspend" [size]="'18px'" [class]="'text-white ml-2'"></app-spinner>
                                    </button>
                                </li>
                                <li>
                                    <button *ngIf="showDelete" id="user-delete" class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" (click)="deletePerson()">Delete
                                        <app-spinner [enabled]="submitSpinnerDelete" [size]="'18px'" [class]="'text-white ml-2'"></app-spinner>
                                    </button>
                                </li>
                                <li>
                                    <button *ngIf="showAnonymize" id="user-anonymize" class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" (click)="openAnonymizePopup()">Anonymize
                                        <app-spinner [enabled]="submitSpinnerAnonymize" [size]="'18px'" [class]="'text-white ml-2'"></app-spinner>
                                    </button>
                                </li>
                            <!-- </ul>
                        </div> -->
                <!-- <li>
                  <button *ngIf="showUnsuspend" id="user-unsuspend"
                    class="btn btn-sm btn-light font-weight-bold text-body mt-2 mr-2" (click)="unsuspendPerson()">
                    Unsuspend
                    <app-spinner [enabled]="submitSpinnerUnsuspend" [size]="'18px'"
                      [class]="'text-body ml-2'"></app-spinner>
                  </button>
                </li>
                <li>
                  <button *ngIf="showSuspend" id="user-suspend"
                    class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" (click)="suspendPerson()">
                    Suspend
                    <app-spinner [enabled]="submitSpinnerSuspend" [size]="'18px'"
                      [class]="'text-white ml-2'"></app-spinner>
                  </button>
                </li>
                <li>
                  <button *ngIf="showDelete" id="user-delete"
                    class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" (click)="deletePerson()">
                    Delete
                    <app-spinner [enabled]="submitSpinnerDelete" [size]="'18px'"
                      [class]="'text-white ml-2'"></app-spinner>
                  </button>
                </li>
                <li>
                  <button *ngIf="showAnonymize" id="user-anonymize"
                    class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" (click)="anonymizePerson()">
                    Anonymize
                    <app-spinner [enabled]="submitSpinnerAnonymize" [size]="'18px'"
                      [class]="'text-white ml-2'"></app-spinner>
                  </button>
                </li>-->
                <li> 
                  <button *ngIf="showAnonymize && showUnlinkButton && showUnlinkbtnOnStatus" id="unlink-user" (click)="enableUnlinkModal()" data-toggle="modal" data-target="#unlink-modal"
                    class="btn btn-sm btn-danger font-weight-bold text-white mt-2 mr-2" >
                    Unlink
                    <!-- <app-spinner [enabled]="submitSpinnerAnonymize" [size]="'18px'"
                      [class]="'text-white ml-2'"></app-spinner> -->
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div class="row row-gap" [ngClass]="this.cuid ? 'mt-4' : 'mt-6'">
            <div class="col-12 col-md-6">
              <div class="card card-light position-relative">
                <div class="position-absolute d-flex justify-content-end w-100">
                  <a data-target="#edit-basic-info-modal" data-backdrop="static" data-keyboard="false"
                    data-toggle="modal" href="#" class="p-2 text-sm" *ngIf="!disableEditing" translate>
                    <img src="https://assets.ot.digital/img/opentext-resources-pencil-ico-primary-72.svg"
                      class="btn-icon btn-icon-first" height="14" width="14" alt="" />
                    edit
                  </a>
                </div>
                <div class="card-body">
                  <h3 class="h5 mb-0" translate>basic-information</h3>
                  <span [hidden]="disableEditing" *ngIf="
                      editPerson.get('name')?.invalid ||
                      editPerson.get('email')?.invalid
                    " class="LV_validation_message LV_invalid" style="display: inline"
                    translate>please-enter-valid-fields</span>
                  <a href="javascript:void(0)" [ngbPopover]="basicInformationErrorPopover" placement="right top bottom"
                    popoverClass="ot-popover" [autoClose]="false" triggers="mouseenter:mouseleave" *ngIf="
                      editPerson.get('name')?.invalid ||
                      editPerson.get('email')?.invalid
                    " [hidden]="disableEditing">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.25011 5.79999V6.54999H9.75011V5.79999H8.25011ZM9.75011 5.78933V5.03933H8.25011V5.78933H9.75011ZM9.75011 12.7333V8.46666H8.25011V12.7333H9.75011ZM9.75011 5.79999V5.78933H8.25011V5.79999H9.75011ZM7.40011 9.74999H9.00011V8.24999H7.40011V9.74999ZM7.40011 12.95H10.6001V11.45H7.40011V12.95ZM9.00011 2.28333C12.7096 2.28333 15.7168 5.29048 15.7168 8.99999H17.2168C17.2168 4.46205 13.5381 0.783326 9.00011 0.783325V2.28333ZM2.28345 8.99999C2.28345 5.29048 5.2906 2.28332 9.00011 2.28333V0.783325C4.46217 0.783325 0.783448 4.46205 0.783447 8.99999H2.28345ZM9.00011 15.7167C5.2906 15.7167 2.28345 12.7095 2.28345 8.99999H0.783447C0.783447 13.5379 4.46217 17.2167 9.00011 17.2167V15.7167ZM9.00011 17.2167C13.5381 17.2167 17.2168 13.5379 17.2168 8.99999H15.7168C15.7168 12.7095 12.7096 15.7167 9.00011 15.7167V17.2167Z"
                        fill="#0066FF" />
                    </svg>
                    <span class="sr-only" translate>basic-information</span>
                  </a>
                  <ng-template #basicInformationErrorPopover>
                    <div class="card card-light-left popover-content">
                      <ul class="list-unstyled mb-0">
                        <li *ngIf="editPerson.get('name.given')?.invalid" translate>
                          first-name-required
                        </li>
                        <li *ngIf="editPerson.get('name.surname')?.invalid" translate>
                          last-name-required
                        </li>
                        <li *ngIf="editPerson.get('email')?.invalid" translate>
                          email-required
                        </li>
                      </ul>
                    </div>
                  </ng-template>
                  <div class="d-flex mt-2 mb-0">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      name
                    </div>
                    <span class="text-truncate" title="{{ getFullNameWithPrefixSuffix() | titlecase }}">
                      {{ getFullNameWithPrefixSuffix() | titlecase }}
                    </span>
                  </div>
                  <div class="d-flex mt-1 mb-0">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      email
                    </div>
                    <span class="text-truncate" isEllipsisActive>{{
                      editPerson.controls.email.value | lowercase
                      }}</span>
                  </div>
                  <ng-container formArrayName="phones" *ngFor="let phone of phoneDetails.controls; let i = index">
                    <ng-container [formGroupName]="i">
                      <div *ngIf="i === 0" class="d-flex mt-1 mb-0">
                        <div class="text-nowrap font-weight-bold mr-1" translate>
                          work-phone
                        </div>
                        <span class="text-truncate" title="{{ phone.get('number')?.value }}">{{
                          phone.get('number')?.value }}</span>
                      </div>
                      <div *ngIf="i === 1" class="d-flex mt-1 mb-0">
                        <div class="text-nowrap font-weight-bold mr-1" translate>
                          mobile
                        </div>
                        <span class="text-truncate" title="{{ phone.get('number')?.value }}">{{
                          phone.get('number')?.value }}</span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>

              <div class="card card-light mt-4" *ngIf="!this.cuid && !disableEditing">
                <div class="position-absolute d-flex justify-content-end w-100">
                  <a href="javascript:void(0)" (click)="isUpdatePasswordShown = !isUpdatePasswordShown"
                    class="p-2 text-sm" translate>
                    <img src="https://assets.ot.digital/img/opentext-resources-pencil-ico-primary-72.svg"
                      class="btn-icon btn-icon-first" height="14" width="14" alt="" />
                    edit
                  </a>
                </div>
                <div class="card-body">
                  <h3 class="h5 mb-0" translate>change-password</h3>
                  <div class="d-flex justify-content-start mt-2 align-items-center">
                    <label for="dummy-password" class="sr-only">Password</label>
                    <input id="dummy-password" class="bg-transparent border-0 d-inline" type="password"
                      value="password12" disabled />
                  </div>
                </div>
              </div>

              <div class="card card-light mt-4">
                <div class="position-absolute d-flex justify-content-end w-100">
                  <a data-target="#address-update-modal" data-toggle="modal" data-backdrop="static"
                    data-keyboard="false" href="#" class="p-2 text-sm" (click)="reset()" *ngIf="!disableEditing"
                    translate>
                    <img src="https://assets.ot.digital/img/opentext-resources-pencil-ico-primary-72.svg"
                      class="btn-icon btn-icon-first" height="14" width="14" alt="" />
                    edit</a>
                </div>
                <ng-container formArrayName="addresses">
                  <ng-container formGroupName="0">
                    <ng-container formArrayName="streets">
                      <div class="card-body">
                        <h3 class="h5 mb-0" translate>address</h3>
                        <span *ngIf="editPerson.get('addresses')?.invalid" [hidden]="disableEditing"
                          class="LV_validation_message LV_invalid" style="display: inline"
                          translate>please-enter-valid-fields</span>
                        <a href="javascript:void(0)" [ngbPopover]="addressInformationErrorPopover"
                          placement="right top bottom" popoverClass="ot-popover" [autoClose]="false"
                          triggers="mouseenter:mouseleave" *ngIf="editPerson.get('addresses')?.invalid"
                          [hidden]="disableEditing">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8.25011 5.79999V6.54999H9.75011V5.79999H8.25011ZM9.75011 5.78933V5.03933H8.25011V5.78933H9.75011ZM9.75011 12.7333V8.46666H8.25011V12.7333H9.75011ZM9.75011 5.79999V5.78933H8.25011V5.79999H9.75011ZM7.40011 9.74999H9.00011V8.24999H7.40011V9.74999ZM7.40011 12.95H10.6001V11.45H7.40011V12.95ZM9.00011 2.28333C12.7096 2.28333 15.7168 5.29048 15.7168 8.99999H17.2168C17.2168 4.46205 13.5381 0.783326 9.00011 0.783325V2.28333ZM2.28345 8.99999C2.28345 5.29048 5.2906 2.28332 9.00011 2.28333V0.783325C4.46217 0.783325 0.783448 4.46205 0.783447 8.99999H2.28345ZM9.00011 15.7167C5.2906 15.7167 2.28345 12.7095 2.28345 8.99999H0.783447C0.783447 13.5379 4.46217 17.2167 9.00011 17.2167V15.7167ZM9.00011 17.2167C13.5381 17.2167 17.2168 13.5379 17.2168 8.99999H15.7168C15.7168 12.7095 12.7096 15.7167 9.00011 15.7167V17.2167Z"
                              fill="#0066FF" />
                          </svg>
                          <span class="sr-only" translate>address</span>
                        </a>
                        <ng-template #addressInformationErrorPopover>
                          <div class="card card-light-left popover-content">
                            <ul class="list-unstyled mb-0">
                              <li *ngIf="
                                  editPerson.get('addresses.0.country')
                                    ?.invalid &&
                                  editPerson.get('addresses.0.country')?.touched
                                " class="help-block" translate>
                                country-required
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                        <ng-container *ngFor="
                            let street of Streets(0).controls;
                            let streetindex = index
                          ">
                          <p class="mt-2 mb-0 text-truncate" *ngIf="streetindex === 0"
                            title="{{ street.value | titlecase }}">
                            {{ street.value | titlecase }}
                          </p>
                          <p class="mb-0 text-truncate" *ngIf="streetindex === 1"
                            title="{{ street.value | titlecase }}">
                            {{ street.value | titlecase }}
                          </p>
                        </ng-container>
                        <p class="mb-0 text-truncate" title="{{ getUserAddress('city') | titlecase }}">
                          {{ getUserAddress('city') | titlecase }}
                        </p>
                        <p class="mb-0 text-truncate" title="{{ getUserAddress('state') | titlecase }}">
                          {{ getUserAddress('state') | titlecase }}
                        </p>
                        <p class="mb-0">
                          {{ getUserAddress('postal') | titlecase }}
                        </p>
                        <p class="mb-0">
                          <ng-container *ngFor="let i of countries">
                            <ng-container *ngIf="i.code == getUserAddress('country')">{{ i.name }}
                            </ng-container>
                          </ng-container>
                        </p>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="card card-light">
                <div class="position-absolute d-flex justify-content-end w-100">
                  <a href="#" data-target="#update-otherInfo-modal" data-toggle="modal" data-backdrop="static"
                    data-keyboard="false" class="p-2 text-sm" (click)="reset()" *ngIf="!disableEditing" translate>
                    <img src="https://assets.ot.digital/img/opentext-resources-pencil-ico-primary-72.svg"
                      class="btn-icon btn-icon-first" height="14" width="14" alt="" />
                    edit
                  </a>
                </div>
                <div class="card-body">
                  <h3 class="h5 mb-0" translate>other-information</h3>
                  <span *ngIf="
                      editPerson.get('language')?.invalid ||
                      editPerson.get('timezone')?.invalid
                    " [hidden]="disableEditing" class="LV_validation_message LV_invalid" style="display: inline"
                    translate>please-enter-valid-fields</span>
                  <a href="javascript:void(0)" [ngbPopover]="otherInformationErrorPopover" placement="right top bottom"
                    popoverClass="ot-popover" [autoClose]="false" triggers="mouseenter:mouseleave" *ngIf="
                      editPerson.get('language')?.invalid ||
                      editPerson.get('timezone')?.invalid
                    " [hidden]="disableEditing">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.25011 5.79999V6.54999H9.75011V5.79999H8.25011ZM9.75011 5.78933V5.03933H8.25011V5.78933H9.75011ZM9.75011 12.7333V8.46666H8.25011V12.7333H9.75011ZM9.75011 5.79999V5.78933H8.25011V5.79999H9.75011ZM7.40011 9.74999H9.00011V8.24999H7.40011V9.74999ZM7.40011 12.95H10.6001V11.45H7.40011V12.95ZM9.00011 2.28333C12.7096 2.28333 15.7168 5.29048 15.7168 8.99999H17.2168C17.2168 4.46205 13.5381 0.783326 9.00011 0.783325V2.28333ZM2.28345 8.99999C2.28345 5.29048 5.2906 2.28332 9.00011 2.28333V0.783325C4.46217 0.783325 0.783448 4.46205 0.783447 8.99999H2.28345ZM9.00011 15.7167C5.2906 15.7167 2.28345 12.7095 2.28345 8.99999H0.783447C0.783447 13.5379 4.46217 17.2167 9.00011 17.2167V15.7167ZM9.00011 17.2167C13.5381 17.2167 17.2168 13.5379 17.2168 8.99999H15.7168C15.7168 12.7095 12.7096 15.7167 9.00011 15.7167V17.2167Z"
                        fill="#0066FF" />
                    </svg>
                    <span class="sr-only" translate>other-information</span>
                  </a>
                  <ng-template #otherInformationErrorPopover>
                    <div class="card card-light-left popover-content">
                      <ul class="list-unstyled mb-0">
                        <li *ngIf="editPerson.get('language')?.invalid" translate>
                          language-required
                        </li>
                        <li *ngIf="editPerson.get('timezone')?.invalid" class="help-block" translate>
                          timezone-required
                        </li>
                      </ul>
                    </div>
                  </ng-template>
                  <div class="d-flex mt-2 mb-0" *ngIf="!hideRole">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      role
                    </div>
                    <ng-container [ngSwitch]="editPerson.controls.userType.value">
                      <span *ngSwitchCase="'partner'" class="text-truncate" isEllipsisActive translate>partner</span>
                      <span *ngSwitchCase="'customer'" class="text-truncate" isEllipsisActive translate>customer</span>
                      <span *ngSwitchDefault class="text-truncate" isEllipsisActive>{{
                        editPerson.controls.userType.value | titlecase
                        }}</span>
                    </ng-container>
                  </div>
                  <div class="d-flex mt-1 mb-0">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      language-preference
                    </div>
                    <ng-container *ngFor="let i of languages">
                      <ng-container *ngIf="i.language == editPerson.controls.language.value">
                        <span class="text-truncate" title="{{ i.title }}">{{
                          i.title
                          }}</span>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="d-flex mt-1 mb-0" *ngIf="!hideOriginatedSystem">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      originated-system
                    </div>
                    <div class="text-truncate" isEllipsisActive>
                      {{ sourceSystem | titlecase }}
                    </div>
                  </div>
                  <div class="d-flex mt-1 mb-0" *ngIf="!hideOriginatedSystem">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      last-updated-from
                    </div>
                    <div class="text-truncate" isEllipsisActive>
                      {{ updateSourceSystem | titlecase }}
                    </div>
                  </div>
                  <div class="d-flex mt-1 mb-0">
                    <div class="text-nowrap font-weight-bold mr-1" translate>
                      timezone
                    </div>
                    <ng-container *ngFor="let i of timeZones">
                      <ng-container *ngIf="i.id == editPerson.controls.timezone.value"><span class="text-truncate"
                          title="{{ i.name }}">{{
                          i.name
                          }}</span>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div class="card card-light mt-4" *ngIf="(isRealmAuthDomain || isEmployeeAuthDomain)">
                <div class="position-absolute d-flex justify-content-end w-100">
                  <!-- MFA Edit functionality is currently disabled -->
                  <a href="#" data-target="#update-mfa-mode-modal" data-toggle="modal" data-backdrop="static"
                  data-keyboard="false" (click)="isUpdateMfaShown = !isUpdateMfaShown" class="p-2 text-sm" *ngIf="!disableEditing && !this.cuid" translate>
                  <img src="https://assets.ot.digital/img/opentext-resources-pencil-ico-primary-72.svg" class="btn-icon btn-icon-first" height="14" width="14" alt="" />
                    edit
                  </a>
                </div>
                <div class="card-body">
                  <h3 class="h5 mb-0" translate>mfa-mode</h3>
                  <div class="d-flex mt-2 mb-0">
                    <div class="font-weight-bold mr-1" translate>
                      status
                    </div>
                    <div class="text-nowrap d-flex mb-0" translate *ngIf="personRoles === 'enabled'">
                      enabled
                    </div>
                    <div class="text-nowrap d-flex mb-0" translate *ngIf="personRoles === 'disabled'">
                      disabled
                    </div>
                    <!-- <div translate>
                      <ng-container [ngSwitch]="editPerson.controls.preferredMode.value">
                        <ng-container *ngSwitchCase="'EMAIL'">email-mfa</ng-container>
                        <ng-container *ngSwitchCase="'VIP'">VIP</ng-container>
                        <ng-container *ngSwitchCase="'SMS'">sms</ng-container>
                        <ng-container *ngSwitchCase="'PHONE'">phone</ng-container>
                        <ng-container *ngSwitchCase="'GA'">google-authenticator<div class="pill pill-sm text-sm bg-success text-white ml-1" translate>
                          active
                        </div></ng-container>
                        <ng-container *ngSwitchDefault>{{
                          editPerson.controls.preferredMode.value
                          }}</ng-container>
                      </ng-container>
                    </div> -->
                  </div>
                  <!-- <div class="text-nowrap d-flex mt-1 mb-0">
                    <ng-container *ngIf="
                        editPerson.controls.preferredMode.value?.toUpperCase() ===
                        'EMAIL'
                      ">
                      <div class="font-weight-bold mr-1" translate>email</div>
                      <div>
                        <span class="text-truncate email-mfa" isEllipsisActive>{{
                          editPerson.controls.email.value | lowercase
                          }}</span>
                        <div class="pill pill-sm text-sm bg-success text-white ml-1" translate>
                          active
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="
                        (editPerson.controls.preferredMode.value?.toUpperCase() ===
                          'PHONE' ||
                          editPerson.controls.preferredMode.value?.toUpperCase() ===
                            'SMS') &&
                        editPerson.controls.phoneVerifiedMode.value?.toUpperCase() ===
                          'MAIN'
                      ">
                      <div class="font-weight-bold mr-1" translate>
                        work-phone
                      </div>
                      <div>
                        {{ getPhoneNumber('main') }}
                        <div class="pill pill-sm text-sm bg-success text-white ml-1" translate>
                          active
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="
                        (editPerson.controls.preferredMode.value?.toUpperCase() ===
                          'PHONE' ||
                          editPerson.controls.preferredMode.value?.toUpperCase() ===
                            'SMS') &&
                        editPerson.controls.phoneVerifiedMode.value?.toUpperCase() ===
                          'MOBILE'
                      ">
                      <div class="font-weight-bold mr-1" translate>mobile</div>
                      <div>
                        {{ getPhoneNumber('mobile') }}
                        <div class="pill pill-sm text-sm bg-success text-white ml-1" translate>
                          active
                        </div>
                      </div>
                    </ng-container>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <div id="edit-basic-info-modal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1"
            aria-labelledby="edit-basic-info-modal-label" aria-modal="true" role="dialog">
            <div class="container">
              <div class="row">
                <div class="col col-lg-8 offset-lg-2">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                    <div class="modal-content bg-transparent border-0">
                      <div class="card card-body card-body-lg card-primary-top shadow pb-0 px-md-0 pt-6 pt-md-8">
                        <button type="button" class="close modal-close" data-dismiss="modal"
                          aria-label="Close Edit mfa information Modal" (click)="isShown = !isShown"
                          (click)="reset()">
                          <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"
                              fill="none">
                              <path d="M1.3999 1.3999L20.5999 20.5999M1.3999 20.5999L20.5999 1.3999" stroke="#0066FF"
                                stroke-width="1.5" />
                            </svg>
                          </span>
                        </button>
                        <div id="edit-basic-info-form" class="modal-body p-0">
                          <div class="container">
                            <div class="row">
                              <div class="col col-md-10 offset-md-1">
                                <h2 id="edit-basic-info-modal-label" class="mb-2 mb-md-3 mb-lg-4" translate>
                                  basic-information
                                </h2>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col col-md-10 offset-md-1 pb-6 pb-md-9">
                                <form [formGroup]="editPerson">
                                  <ng-container formGroupName="name">
                                    <div class="form-group">
                                      <label for="prefix" translate>prefix</label>
                                      <select id="prefix" formControlName="prefix" class="form-control">
                                        <option value="" disabled selected hidden translate>
                                          select
                                        </option>
                                        <option value="{{ 'mr' | translate }}" translate>
                                          mr
                                        </option>
                                        <option value="{{ 'ms' | translate }}" translate>
                                          ms
                                        </option>
                                        <option value="{{ 'mx' | translate }}" translate>
                                          mx
                                        </option>
                                        <option value="{{ 'dr' | translate }}" translate>
                                          dr
                                        </option>
                                      </select>
                                    </div>
                                    <div class="form-group">
                                      <label for="given" translate><span
                                          class="text-danger mr-1">*</span>first-name</label>
                                      <input type="text" class="form-control" maxlength="150" name="given" id="given"
                                        formControlName="given" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('name.given')
                                              ?.invalid &&
                                            editPerson.get('name.given')
                                              ?.touched
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('name.given')
                                            ?.invalid &&
                                          editPerson.get('name.given')
                                            ?.touched &&
                                          editPerson.get('name.given')?.errors
                                            ?.message != 'urlRestricted'
                                        " [control2]="'first-name-required'"></app-error-message>
                                      <app-error-message *ngIf="
                                          editPerson.get('name.given')?.errors
                                            ?.message === 'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                    <div class="form-group">
                                      <label for="middle" translate>middle-initial</label>
                                      <input type="text" class="form-control" name="middle" id="middle" maxlength="60"
                                        formControlName="middle" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('name.middle')
                                              ?.invalid
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('name.middle')?.errors
                                            ?.message === 'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                    <div class="form-group">
                                      <label for="surname" translate><span
                                          class="text-danger mr-1">*</span>last-name</label>
                                      <input type="text" class="form-control" name="surname" id="surname"
                                        maxlength="150" formControlName="surname" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('name.surname')
                                              ?.invalid &&
                                            editPerson.get('name.surname')
                                              ?.touched
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('name.surname')
                                            ?.invalid &&
                                          editPerson.get('name.surname')
                                            ?.touched &&
                                          editPerson.get('name.surname')?.errors
                                            ?.message != 'urlRestricted'
                                        " [control2]="'last-name-required'"></app-error-message>
                                      <app-error-message *ngIf="
                                          editPerson.get('name.surname')?.errors
                                            ?.message === 'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                    <div class="form-group">
                                      <label for="suffix" translate>suffix</label>
                                      <input type="text" class="form-control" name="suffix" id="suffix" maxlength="50"
                                        formControlName="suffix" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('name.suffix')
                                              ?.invalid
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('name.suffix')?.errors
                                            ?.message === 'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                  </ng-container>
                                  <div class="form-group">
                                    <label for="email" translate><span class="text-danger mr-1">*</span>email</label>
                                    <input type="email" class="form-control" name="email" id="email" maxlength="1000"
                                      formControlName="email" [ngClass]="{
                                        LV_invalid_field:
                                          editPerson.get('email')?.invalid &&
                                          editPerson.get('email')?.touched
                                      }" />
                                    <div *ngIf="
                                        editPerson.get('email')?.invalid &&
                                        editPerson.get('email')?.touched
                                      ">
                                      <app-error-message *ngIf="
                                          editPerson.get('email')?.errors
                                            ?.message === 'empty' &&
                                          editPerson.get('email')?.errors
                                            ?.message != 'urlRestricted'
                                        " [control2]="'email-empty'"></app-error-message>
                                      <app-error-message *ngIf="
                                          editPerson.get('email')?.errors
                                            ?.message === 'format'
                                        " [control2]="'email-required'"></app-error-message>
                                      <app-error-message *ngIf="
                                          editPerson.get('email')?.errors
                                            ?.message === 'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                  </div>
                                  <div class="form-group" formArrayName="phones" *ngFor="
                                      let item of phoneDetails.controls;
                                      let i = index
                                    ">
                                    <ng-container [formGroupName]="i">
                                      <label *ngIf="i === 0" translate>work-phone</label>
                                      <label *ngIf="i === 1" translate>mobile</label>
                                      <input class="form-control" maxlength="15" id="number" type="text" (input)="filterDigitsOnlyforMobile($event)"
                                        formControlName="number" aria-label="contact-details" [ngClass]="{
                                          LV_invalid_field:
                                            isPhoneNumberInvalid(i)
                                        }" />
                                    </ng-container>
                                    <ng-container *ngIf="i === 0">
                                      <app-error-message *ngIf="
                                          editPerson.get('phones.0.number')
                                            ?.errors?.message ===
                                          'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </ng-container>
                                    <ng-container *ngIf="i === 1">
                                      <app-error-message *ngIf="
                                          editPerson.get('phones.1.number')
                                            ?.errors?.message ===
                                          'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </ng-container>
                                  </div>
                                  <div>
                                    <button class="btn btn-outline-primary" id="custom-modal-fade-info" type="button"
                                      (click)="reset()" data-dismiss="modal" translate hidden>
                                      close
                                    </button>
                                    <button class="btn btn-primary" id="custom-modal-fade" [attr.data-dismiss]="
                                        this.fadeModal ? 'modal' : null
                                      " (click)="
                                        onSubmit(
                                          'custom-modal-fade-info',
                                          editPerson.get('name')?.valid &&
                                            editPerson.get('email')?.valid &&
                                            editPerson.get('phones')?.valid
                                        )
                                      " translate>
                                      update
                                      <app-spinner [enabled]="submitSpinner" [size]="'23px'"
                                        [class]="'text-light ml-2'">
                                      </app-spinner>
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <app-update-password *ngIf="!isUpdatePasswordShown || false"
            (closeClicked)="getNotificationFromPassword($event)"></app-update-password>

          <div id="address-update-modal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1"
            aria-labelledby="address-update-modal-label" aria-modal="true" role="dialog">
            <div class="container">
              <div class="row">
                <div class="col col-lg-8 offset-lg-2">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                    <div class="modal-content bg-transparent border-0">
                      <div class="card card-body card-body-lg card-primary-top shadow pb-0 px-md-0 pt-6 pt-md-8">
                        <button type="button" class="close modal-close" data-dismiss="modal"
                          aria-label="Close Edit address information Modal" (click)="reset()">
                          <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"
                              fill="none">
                              <path d="M1.3999 1.3999L20.5999 20.5999M1.3999 20.5999L20.5999 1.3999" stroke="#0066FF"
                                stroke-width="1.5" />
                            </svg>
                          </span>
                        </button>
                        <div class="modal-body p-0">
                          <div class="container">
                            <div class="row">
                              <div class="col col-md-10 offset-md-1">
                                <h2 id="address-update-modal-label" class="mb-2 mb-md-3 mb-lg-4" translate>
                                  address
                                </h2>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col col-md-10 offset-md-1 pb-6 pb-md-9">
                                <ng-container formArrayName="addresses">
                                  <ng-container formGroupName="0">
                                    <div class="form-group" formArrayName="streets" *ngFor="
                                        let street of Streets(0).controls;
                                        let i = index
                                      ">
                                      <label *ngIf="i === 0" translate>address-1</label>
                                      <label *ngIf="i === 1" translate>address-2</label>
                                      <input type="text" class="form-control" id="alias-{{ i }}"
                                        aria-label="street-address" maxlength="255" [formControlName]="i" [ngClass]="{
                                          LV_invalid_field: isStreetInvalid(
                                            0,
                                            i
                                          )
                                        }" />
                                      <ng-container *ngIf="i === 0">
                                        <app-error-message *ngIf="
                                            editPerson.get(
                                              'addresses.0.streets.0'
                                            )?.errors?.message ===
                                            'urlRestricted'
                                          " [control2]="'url-restricted'"></app-error-message>
                                      </ng-container>
                                      <ng-container *ngIf="i === 1">
                                        <app-error-message *ngIf="
                                            editPerson.get(
                                              'addresses.0.streets.1'
                                            )?.errors?.message ===
                                            'urlRestricted'
                                          " [control2]="'url-restricted'"></app-error-message>
                                      </ng-container>
                                    </div>
                                    <div class="form-group">
                                      <label for="city" translate>city</label>
                                      <input type="text" class="form-control" id="city" maxlength="60"
                                        formControlName="city" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('addresses.0.city')
                                              ?.invalid
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('addresses.0.city')
                                            ?.errors?.message ===
                                          'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                    <div class="form-group">
                                      <label for="state" translate>state</label>
                                      <input type="text" class="form-control" id="state" maxlength="60"
                                        formControlName="state" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('addresses.0.state')
                                              ?.invalid
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('addresses.0.state')
                                            ?.errors?.message ===
                                          'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                    <div class="form-group">
                                      <label for="postal" translate>postal-code</label>
                                      <input type="text" class="form-control" id="postal" maxlength="10"
                                        formControlName="postal" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get('addresses.0.postal')
                                              ?.invalid
                                        }" />
                                      <app-error-message *ngIf="
                                          editPerson.get('addresses.0.postal')
                                            ?.errors?.message ===
                                          'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                    <div class="form-group">
                                      <label for="country" translate><span
                                          class="text-danger mr-1">*</span>country</label>
                                      <select id="country" formControlName="country" class="form-control" [ngClass]="{
                                          LV_invalid_field:
                                            editPerson.get(
                                              'addresses.0.country'
                                            )?.invalid &&
                                            editPerson.get(
                                              'addresses.0.country'
                                            )?.touched
                                        }">
                                        <option value="" disabled selected hidden translate>
                                          select
                                        </option>
                                        <option *ngFor="let i of countries" value="{{ i.code }}">
                                          {{ i.name }}
                                        </option>
                                      </select>

                                      <app-error-message *ngIf="
                                          editPerson.get('addresses.0.country')
                                            ?.invalid &&
                                          editPerson.get('addresses.0.country')
                                            ?.touched &&
                                          editPerson.get('addresses.0.country')
                                            ?.errors?.message != 'urlRestricted'
                                        " [control2]="'country-required'">
                                      </app-error-message>
                                      <app-error-message *ngIf="
                                          editPerson.get('addresses.0.country')
                                            ?.errors?.message ===
                                          'urlRestricted'
                                        " [control2]="'url-restricted'"></app-error-message>
                                    </div>
                                  </ng-container>
                                </ng-container>
                                <div>
                                  <button class="btn btn-outline-primary" id="custom-modal-fade-add-close" type="button"
                                    (click)="reset()" data-dismiss="modal" translate hidden>
                                    close
                                  </button>
                                  <button class="btn btn-primary" id="custom-modal-fade-add" [attr.data-dismiss]="
                                      this.fadeModal ? 'modal' : null
                                    " (click)="
                                      onSubmit(
                                        'custom-modal-fade-add-close',
                                        editPerson.get('addresses')?.valid
                                      )
                                    " translate>
                                    update
                                    <app-spinner [enabled]="submitSpinner" [size]="'23px'" [class]="'text-light ml-2'">
                                    </app-spinner>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="update-otherInfo-modal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1"
            aria-labelledby="update-otherInfo-modal-label" aria-modal="true" role="dialog">
            <div class="container">
              <div class="row">
                <div class="col col-lg-8 offset-lg-2">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                    <div class="modal-content bg-transparent border-0">
                      <div class="card card-body card-body-lg card-primary-top shadow pb-0 px-md-0 pt-6 pt-md-8">
                        <button type="button" class="close modal-close" data-dismiss="modal"
                          aria-label="Close Edit other information Modal" (click)="reset()">
                          <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"
                              fill="none">
                              <path d="M1.3999 1.3999L20.5999 20.5999M1.3999 20.5999L20.5999 1.3999" stroke="#0066FF"
                                stroke-width="1.5" />
                            </svg>
                          </span>
                        </button>
                        <div class="modal-body p-0">
                          <div class="container">
                            <div class="row">
                              <div class="col col-md-10 offset-md-1">
                                <h2 id="update-otherInfo-modal-label" class="mb-2 mb-md-3 mb-lg-4" translate>
                                  other-information
                                </h2>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col col-md-10 offset-md-1 pb-6 pb-md-9">
                                <div class="form-group">
                                  <label for="language" translate><span
                                      class="text-danger mr-1">*</span>language-preference</label>
                                  <select id="language" formControlName="language" class="form-control" [ngClass]="{
                                      LV_invalid_field:
                                        editPerson.get('language')?.invalid &&
                                        editPerson.get('language')?.touched
                                    }">
                                    <option value="" disabled selected hidden translate>
                                      select
                                    </option>
                                    <option *ngFor="let i of languages" value="{{ i.language }}">
                                      {{ i.title }}
                                    </option>
                                  </select>
                                  <app-error-message *ngIf="
                                      editPerson.get('language')?.invalid &&
                                      editPerson.get('language')?.touched
                                    " [control2]="'language-required'"></app-error-message>
                                </div>

                                <div class="form-group">
                                  <label for="timezone" translate><span
                                      class="text-danger mr-1">*</span>timezone</label>
                                  <select id="timezone" formControlName="timezone" class="form-control" [ngClass]="{
                                      LV_invalid_field:
                                        editPerson.get('timezone')?.invalid &&
                                        editPerson.get('timezone')?.touched
                                    }">
                                    <option value="" disabled selected hidden translate>
                                      select
                                    </option>
                                    <option *ngFor="let i of TimeZones()" value="{{ i.id }}">
                                      {{ i.name }}
                                    </option>
                                  </select>
                                  <app-error-message *ngIf="
                                      editPerson.get('timezone')?.invalid &&
                                      editPerson.get('timezone')?.touched
                                    " [control2]="'timezone-required'"></app-error-message>
                                </div>
                                <div>
                                  <button class="btn btn-outline-primary" id="custom-modal-fade-info2" type="button"
                                    (click)="reset()" data-dismiss="modal" translate hidden>
                                    close
                                  </button>
                                  <button class="btn btn-primary" (click)="
                                      onSubmit(
                                        'custom-modal-fade-info2',
                                        editPerson.get('language')?.valid &&
                                          editPerson.get('timezone')?.valid
                                      )
                                    " translate>
                                    update
                                    <app-spinner [enabled]="submitSpinner" [size]="'23px'" [class]="'text-light ml-2'">
                                    </app-spinner>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <app-update-mfa *ngIf="!isUpdateMfaShown || false" (closeClicked)="getNotificationFromMfa($event)"
            [editForm]="editPerson" [personRoles]="personRoles" (statusChange)="onStatusChange($event)"></app-update-mfa>

          <app-reset-password *ngIf="!isResetPasswordShown || false"
            (closeClicked)="getNotificationFromResetPassword($event)"
            [personDetails]="personDetails"></app-reset-password>
        </form>
      </div>
    </div>
  </section>

  <!-- Anonymize Popup -->
  <!-- Button trigger modal -->
  <button type="button" class="btn btn-primary" data-toggle="modal" id="launch-modal" hidden
    data-target="#exampleModalCenter">
    Launch demo modal
  </button>

  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" id="anonymize-dialog-centered" role="document">
      <div class="modal-content" id="anonymize-content">
        <div class="modal-header" id="anonymize-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Anonymize user</h5>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body">
          This action will permanently delete the user. Would you still like to
          proceed with anonymizing the user?
        </div>
        <div class="modal-footer" id="anonymize-footer">
          <button type="button" class="btn btn-outline-secondary mr-auto" id="anonymize-cancel-btn"
            data-dismiss="modal" translate>
            cancel
          </button>
          <button type="button" class="btn btn-primary more" style="padding-right: 2.5rem;
          padding-left: 1rem;" data-dismiss="modal" (click)="anonymizePerson()">
            Anonymize User
          </button>
        </div>
      </div>
    </div>
  </div>

  <button class="float-end" id="reset-password" href="" type="button" hidden data-target="#anonymize-modal"
    data-toggle="modal" data-backdrop="static">
    Open
  </button>
  <!-- Anonymize Popup End-->

  <!-- Unlink modal start -->
  <div id="unlink-modal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="contact-modal-label" aria-modal="true" role="dialog">
    <div class="container" id="unlink-modal-container">
      <div class="row">
        <div class="col-12 col-lg-8 offset-lg-2">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
            <div class="modal-content bg-transparent border-0">
              <div class="card card-body card-body-lg card-primary-top shadow pb-0 px-md-0 pt-6 pt-md-8">
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close Contact Modal">
                  <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <path d="M1.3999 1.3999L20.5999 20.5999M1.3999 20.5999L20.5999 1.3999" stroke="#0066FF"
                        stroke-width="1.5" />
                    </svg>
                  </span>
                </button>

                <div class="modal-body" id="modal-body-content">
                  <div id="v-linked-accounts" class="tab-pane fade show active" role="tabpanel"
                    aria-labelledby="v-linked-accounts-tab">
                    <!-- <div class="container"> -->
                      <div class="row row-gap row-cols-1">
                        <div class="col">
                          <div class="alert-fixed-container">
                            <div class="container">
                              <div class="row justify-content-center">
                                <div class="col-12 col-md-10 col-lg-6">
                                  <div class="alert-container"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex align-items-center mb-2">
                            <svg class="text-primary mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M16.8304 13.6077L21.662 8.77696C22.0851 8.35403 22.4208 7.85192 22.6498 7.29929C22.8789 6.74665 22.9969 6.15432 22.997 5.55611C22.9971 4.9579 22.8793 4.36552 22.6505 3.81281C22.4216 3.26009 22.0861 2.75786 21.6631 2.33479C21.2401 1.91171 20.7379 1.57608 20.1852 1.34706C19.6325 1.11804 19.04 1.00011 18.4417 1C17.8434 0.999894 17.2509 1.11762 16.6981 1.34644C16.1453 1.57527 15.643 1.91072 15.2199 2.33365L10.3883 7.1667M7.16511 10.3873L2.33581 15.2181C1.48094 16.0722 1.00043 17.2309 1 18.4392C0.999573 19.6476 1.47926 20.8066 2.33354 21.6614C3.18781 22.5161 4.3467 22.9965 5.55525 22.997C6.76381 22.9974 7.92303 22.5178 8.77791 21.6637L13.6095 16.8374M16.0264 7.97291L7.97156 16.0242"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                              </path>
                            </svg>
                            <h2 class="h5 mb-0" translate>Linked accounts</h2>
                          </div>
                          <div class="card card-light card-body pb-1 pb-lg-3" id="linked-account-card">
                            <div class="table-responsive table-responsive-shadow-md" id="linked-table">
                              <table role="table" class="table table-borderless table-striped text-sm">
                                <thead role="rowgroup" class="text-sm">
                                  <tr role="row">
                                      <th role="columnheader" class="pt-0 pb-1 border-0" translate>System</th>
                                      <th role="columnheader" class="pt-0 pb-1 border-0" translate>User ID</th>
                                      <th role="columnheader" class="pt-0 pb-1 text-right border-0" translate>Action</th>
                                  </tr>
                                </thead>
                                <tbody role="rowgroup" id="linked-account-list">
                                  <tr role="row" class="linked-table-row">
                                    <td role="cell" class=" mb-0 text-truncate td-heading border-0" id="remove-text-truncate" style="max-width: 200px;">
                                      <div class="d-flex flex-wrap align-items-center td-content">
                                        <p class="mb-0 system-name" id="td-data-first-row" style="white-space: nowrap;">
                                          {{IdpModel[0]?.providerName}}
                                          <a href="javascript:void(0)" [ngbPopover]="accountIdPopover" placement="right bottom" popoverClass="ot-popover" [autoClose]="false" triggers="mouseenter:mouseleave">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M8.25011 5.80011V6.55011H9.75011V5.80011H8.25011ZM9.75011 5.78945V5.03945H8.25011V5.78945H9.75011ZM9.75011 12.7334V8.46678H8.25011V12.7334H9.75011ZM9.75011 5.80011V5.78945H8.25011V5.80011H9.75011ZM7.40011 9.75011H9.00011V8.25011H7.40011V9.75011ZM7.40011 12.9501H10.6001V11.4501H7.40011V12.9501ZM9.00011 2.28345C12.7096 2.28345 15.7168 5.2906 15.7168 9.00011H17.2168C17.2168 4.46217 13.5381 0.783448 9.00011 0.783447V2.28345ZM2.28345 9.00011C2.28345 5.2906 5.2906 2.28345 9.00011 2.28345V0.783447C4.46217 0.783447 0.783448 4.46217 0.783447 9.00011H2.28345ZM9.00011 15.7168C5.2906 15.7168 2.28345 12.7096 2.28345 9.00011H0.783447C0.783447 13.5381 4.46217 17.2168 9.00011 17.2168V15.7168ZM9.00011 17.2168C13.5381 17.2168 17.2168 13.5381 17.2168 9.00011H15.7168C15.7168 12.7096 12.7096 15.7168 9.00011 15.7168V17.2168Z"
                                                    fill="currentColor"></path>
                                            </svg>
                                            <!-- <span class="sr-only">{{productLineHelpText}}</span> -->
                                          </a>
                                            <ng-template #accountIdPopover>
                                                <div class='card card-light-left popover-content'>
                                                    <ul class='list-unstyled mb-0'>
                                                        <li translate>OT Connect - The login portal for systems related to your OpenText Connect Account</li>
                                                    </ul>
                                                </div>
                                            </ng-template>
                                              <span class="badge badge-primary badge-pill font-weight-normal ml-1" id="primary-badge" style="font-weight: 300!important; font-size: 10px!important; line-height: 16px; margin-left: 4px!important;" translate>Primary</span>
                                        </p>
                                        
                                      </div>
                                    </td>
                                    <td role="cell" class=" mb-0 text-truncate td-heading border-0" id="linked-user-id" style="max-width: 200px;">
                                      <div class="d-flex flex-wrap align-items-center text-truncate td-content">
                                        <p class="mb-0 camel-case" id="first-letter" [innerHTML]="tooltipTitle" title="{{tooltipTitle}}" isEllipsisActive>
                                          {{IdpModel[0]?.primaryUserName}}
                                        </p>
                                      </div>
                                    </td>
                                    <td  role="cell"class=" mb-0 text-truncate border-0 td-heading" style="white-space: normal;">
                                      <div class="d-flex align-items-center" id="justify-content">
                                        <svg class="mr-1" width="18" height="18" viewBox="0 0 18 18" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M8.25011 5.80011V6.55011H9.75011V5.80011H8.25011ZM9.75011 5.78945V5.03945H8.25011V5.78945H9.75011ZM9.75011 12.7334V8.46678H8.25011V12.7334H9.75011ZM9.75011 5.80011V5.78945H8.25011V5.80011H9.75011ZM7.40011 9.75011H9.00011V8.25011H7.40011V9.75011ZM7.40011 12.9501H10.6001V11.4501H7.40011V12.9501ZM9.00011 2.28345C12.7096 2.28345 15.7168 5.2906 15.7168 9.00011H17.2168C17.2168 4.46217 13.5381 0.783448 9.00011 0.783447V2.28345ZM2.28345 9.00011C2.28345 5.2906 5.2906 2.28345 9.00011 2.28345V0.783447C4.46217 0.783447 0.783448 4.46217 0.783447 9.00011H2.28345ZM9.00011 15.7168C5.2906 15.7168 2.28345 12.7096 2.28345 9.00011H0.783447C0.783447 13.5381 4.46217 17.2168 9.00011 17.2168V15.7168ZM9.00011 17.2168C13.5381 17.2168 17.2168 13.5381 17.2168 9.00011H15.7168C15.7168 12.7096 12.7096 15.7168 9.00011 15.7168V17.2168Z"
                                            fill="currentColor"></path>
                                        </svg>
                                        <span class="primary-account-message" style="white-space: normal;" isEllipsisActive translate>Primary account cannot be unlinked</span>
                                      </div>
                                    </td>
                                  </tr>

                                  <tr role="row" class="linked-table-row" *ngFor="let idpDetails of IdpModel; let i = index">
                                    <td role="cell" class="td-heading mb-0 text-truncate border-0" id="remove-text-truncate" style="max-width: 200px;">
                                      <div class="d-flex flex-wrap align-items-center td-content">
                                        <p class="mb-0 system-name" id="td-data" style="white-space: nowrap;">
                                          {{idpDetails.providerName}}
                                          <a href="javascript:void(0)" [ngbPopover]="accountIdPopover" placement="right top bottom" popoverClass="ot-popover" [autoClose]="false" triggers="mouseenter:mouseleave">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M8.25011 5.80011V6.55011H9.75011V5.80011H8.25011ZM9.75011 5.78945V5.03945H8.25011V5.78945H9.75011ZM9.75011 12.7334V8.46678H8.25011V12.7334H9.75011ZM9.75011 5.80011V5.78945H8.25011V5.80011H9.75011ZM7.40011 9.75011H9.00011V8.25011H7.40011V9.75011ZM7.40011 12.9501H10.6001V11.4501H7.40011V12.9501ZM9.00011 2.28345C12.7096 2.28345 15.7168 5.2906 15.7168 9.00011H17.2168C17.2168 4.46217 13.5381 0.783448 9.00011 0.783447V2.28345ZM2.28345 9.00011C2.28345 5.2906 5.2906 2.28345 9.00011 2.28345V0.783447C4.46217 0.783447 0.783448 4.46217 0.783447 9.00011H2.28345ZM9.00011 15.7168C5.2906 15.7168 2.28345 12.7096 2.28345 9.00011H0.783447C0.783447 13.5381 4.46217 17.2168 9.00011 17.2168V15.7168ZM9.00011 17.2168C13.5381 17.2168 17.2168 13.5381 17.2168 9.00011H15.7168C15.7168 12.7096 12.7096 15.7168 9.00011 15.7168V17.2168Z"
                                                    fill="currentColor"></path>
                                            </svg>
                                            <!-- <span class="sr-only">{{productLineHelpText}}</span> -->
                                          </a>
                                          <ng-template #accountIdPopover>
                                              <div class='card card-light-left popover-content'>
                                                  <ul class='list-unstyled mb-0'>
                                                      <li translate>OT Connect - The login portal for systems related to your OpenText Connect Account</li>
                                                  </ul>
                                              </div>
                                          </ng-template>
                                        </p>
                                      </div>
                                    </td>
                                    <td role="cell" class=" mb-0 text-truncate td-heading border-0" id="linked-user-id" style="max-width: 200px;"> 
                                      <div class="d-flex flex-wrap align-items-center text-truncate td-content">
                                        <p class="mb-0 camel-case" id="first-letter" isEllipsisActive>
                                          {{idpDetails.linkedUserName}}
                                        </p>
                                      </div>
                                    </td>
                                    <td role="cell" class=" mb-0 text-truncate border-0 td-heading">
                                      <div class="d-flex justify-content-end align-items-center td-content" id="unlink-button">
                                        <a class="d-flex align-items-center text-danger link-btn" id="unlink-click" data-toggle="modal"
                                          data-target="#confirm-unlink-modal" data-dismiss="modal">
                                          <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                              d="M11.5655 8.73586L14.4447 5.85169C14.7269 5.56964 14.9508 5.23478 15.1035 4.86622C15.2563 4.49766 15.335 4.10263 15.335 3.70368C15.3351 3.30472 15.2566 2.90966 15.104 2.54105C14.9513 2.17244 14.7276 1.8375 14.4455 1.55534C14.1634 1.27319 13.8285 1.04936 13.4598 0.896619C13.0912 0.743881 12.6961 0.665232 12.2971 0.665161C11.8981 0.665091 11.503 0.7436 11.1343 0.896207C10.7656 1.04881 10.4306 1.27253 10.1484 1.55458L8.21226 3.49712M4.43729 7.26555L1.55591 10.1473C0.98578 10.717 0.665324 11.4897 0.665039 12.2956C0.664754 13.1014 0.984663 13.8744 1.55439 14.4444C2.12411 15.0145 2.89699 15.3349 3.70298 15.3352C4.50898 15.3354 5.28208 15.0156 5.85221 14.446L7.79209 12.5104M4.9714 2.95875L11.1543 12.9151"
                                              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                                          </svg>
                                          <span style="font-size: 16px;" (click)="confirmUnlinkIdp(idpDetails)" translate>Unlink</span>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                          </div>
                          </div>
                        </div>
                      </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- unlink modal end -->

  <!-- confirmation unlink modal start -->
  <div id="confirm-unlink-modal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="contact-modal-label" aria-modal="true" role="dialog">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-4">
                
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">

                    <div class="js-ajax-submit-container modal-content bg-transparent border-0">

                        <div class="js-ajax-submit-form card card-body card-primary-top shadow pb-0 px-md-0">
    
                            <div class="modal-body p-0">
                                <div class="container">                              
                                    <div class="row">
                                        <div class="col-12 col-md-10">
                                            <div class="opentext-unlink-ico" id="unlink-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                                    <g id="opentext-unlink-ico">
                                                    <path id="vector" fill-rule="evenodd" clip-rule="evenodd" d="M32.8045 2.25326C34.0064 1.75573 35.2946 1.49977 36.5955 1.5C37.8964 1.50023 39.1845 1.75664 40.3863 2.2546C41.5881 2.75256 42.68 3.48232 43.5997 4.40222C44.5194 5.32212 45.2489 6.41414 45.7466 7.61594C46.2442 8.81775 46.5002 10.1058 46.5 11.4065C46.4998 12.7073 46.2433 13.9952 45.7452 15.1968C45.2472 16.3985 44.5173 17.4902 43.5972 18.4098L35.1587 26.8629C34.7686 27.2538 34.1354 27.2543 33.7445 26.8642C33.3537 26.474 33.3531 25.8408 33.7433 25.4499L42.1834 16.9952C42.9177 16.2613 43.5002 15.39 43.8977 14.431C44.2951 13.4721 44.4998 12.4442 44.5 11.4062C44.5002 10.3681 44.2959 9.3402 43.8987 8.38109C43.5016 7.42198 42.9194 6.55046 42.1854 5.8163C41.4513 5.08214 40.5799 4.49971 39.6207 4.10227C38.6615 3.70484 37.6334 3.50018 36.5952 3.5C35.5569 3.49982 34.5287 3.70411 33.5694 4.1012C32.6105 4.49814 31.7391 5.07996 31.005 5.81345C31.0047 5.81374 31.0044 5.81403 31.0041 5.81432L25.3303 11.5068C24.9404 11.898 24.3073 11.899 23.9161 11.5092C23.5249 11.1193 23.5239 10.4861 23.9138 10.0949L29.5889 4.40109L29.5903 4.39974C30.5103 3.48017 31.6025 2.7508 32.8045 2.25326ZM14.5951 8.37334C15.0642 8.08198 15.6808 8.22613 15.9721 8.69531L34.0952 37.879C34.3866 38.3482 34.2424 38.9647 33.7733 39.2561C33.3041 39.5474 32.6875 39.4033 32.3962 38.9341L14.2731 9.75041C13.9817 9.28124 14.1259 8.6647 14.5951 8.37334ZM14.2641 21.1396C14.6547 21.5301 14.6547 22.1633 14.2642 22.5538L5.81843 31.0007C4.33492 32.483 3.50074 34.494 3.5 36.5909C3.49926 38.6877 4.33165 40.699 5.81412 42.1822C7.29658 43.6655 9.30769 44.4993 11.405 44.5C13.5024 44.5007 15.5141 43.6684 16.9976 42.1862L22.6841 36.5122C23.0751 36.1221 23.7083 36.1228 24.0984 36.5138C24.4884 36.9047 24.4877 37.5379 24.0968 37.928L18.4112 43.601C16.5524 45.4582 14.032 46.5009 11.4043 46.5C8.77666 46.4991 6.25695 45.4545 4.39952 43.5961C2.54208 41.7376 1.49907 39.2175 1.5 36.5901C1.50093 33.9629 2.54559 31.4437 4.40412 29.5866C4.404 29.5867 4.40423 29.5865 4.40412 29.5866L12.8499 21.1397C13.2404 20.7491 13.8736 20.7491 14.2641 21.1396Z" fill="#0066FF"/>
                                                    </g>
                                                </svg>  
                                            </div>
                                            <h3 class="h5 heading-regular" *ngIf=" selectedLanguage != 'ja' " id="popup-body" translate>Are you sure you want to unlink the <strong>{{selectedIdp?.providerName}}</strong> <span translate>account:</span> {{selectedIdp?.linkedUserName}} <span translate>?</span></h3>
                                            <h3 class="h5 heading-regular" *ngIf=" selectedLanguage == 'ja' " id="popup-body" translate><strong>{{selectedIdp?.providerName}}</strong> <span translate>account:</span> {{selectedIdp?.linkedUserName}} <span translate>Are you sure you want to unlink the</span> <span translate>?</span></h3>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="modal-footer" style="border: none;">
                                <button class="btn btn-outline-primary mr-auto" type="button" data-dismiss="modal" translate>cancel</button>
                                <button class="btn btn-primary more cursor-pointer" style="padding: 12px 40px 12px 24px;" type="button" (click)="unlinkIdp(selectedIdp?.linkedId, selectedIdp?.linkedUserName)" data-dismiss="modal" translate>continue</button>
                            </div>
            
                        </div>
            
                    </div>

                </div>
                
            </div>
        </div>
    <!-- </section> -->
     <!-- Anonymize Popup -->
    <!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" id="launch-modal" hidden data-target="#exampleModalCenter">
    Launch demo modal
  </button>
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" id="anonymize-dialog-centered" role="document">
      <div class="modal-content" id="anonymize-content">
        <div class="modal-header" id="anonymize-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Anonymize User</h5>
        </div>
        <div class="modal-body" id="anonymize-body">
            <p class="body-text"> This action will permanently delete the user.<br>Would you still like to proceed with<br>anonymizing the user?</p>
        </div>
        <div class="modal-footer" id="anonymize-footer">
          <button type="button" class="btn btn-outline-secondary mr-auto" id="anonymize-cancel-btn" data-dismiss="modal" translate>cancel </button>
          <button type="button" class="btn btn-primary" id="anonymize-btn" data-dismiss="modal" (click)="anonymizePerson()">Anonymize User <svg xmlns="http://www.w3.org/2000/svg" width="23.24" height="24.5" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" stroke="white" stroke-width="0.5"/>
          </svg></button>
        </div>
      </div>
    </div>
  </div> -->
    </div>  
</div>
  <!-- confirmation unlink modal End -->
  <router-outlet></router-outlet>
</div>